import { render, staticRenderFns } from "./ProducersModule.vue?vue&type=template&id=646bd7a5&"
import script from "./ProducersModule.vue?vue&type=script&lang=js&"
export * from "./ProducersModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports